import { pick, stripUndefined } from 'ts-utils';
import { ApiClient } from '../../../api/ApiClient';
import { getUtmParams } from '../../../config/AssessmentUtils';
import { recordError } from '../../../util/Errors';
import { translate } from '../../../util/Localization';
import { makeUserFriendlyError } from '../../../util/UserFriendlyError';
import { ActionType } from '../../ActionTypes';
import { store as baseStore } from '../../Store';

/** Creates or updates a Stripe Checkout Session using the details in the purchase state. */
export async function createCheckout(store = baseStore): Promise<void> {
  const { pricing, purchase, user } = store.getState();

  if (user?.userId !== undefined && !purchase.payment.loading) {
    try {
      store.dispatch({ type: ActionType.CREATE_CHECKOUT_LOADING });

      const result = await new ApiClient(purchase.addonProduct).checkout(
        stripUndefined({
          userId: user.userId,
          ...pick(purchase, ['plan', 'trialPeriodDays', 'trialPlan', 'addonPlan']),
          ...pick(pricing, ['currency', 'couponCode']),
          ...getUtmParams(),
        })
      );

      store.dispatch({ type: ActionType.CREATE_CHECKOUT_SUCCESS, result });
    } catch (baseError) {
      const error = makeUserFriendlyError(
        baseError,
        'Something went wrong while preparing your purchase. ' +
          `If you already have an account, please login through the ${translate('product')} app.`
      );
      recordError(error);

      store.dispatch({ type: ActionType.CREATE_CHECKOUT_FAILURE, error });
    }
  }
}
